var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_3535",
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13739",
    "data-name": "Group 13739",
    transform: "translate(-1238.711 -142.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13737",
    "data-name": "Group 13737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13738",
    "data-name": "Group 13738"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1238.71, 142.13)",
    filter: "url(#Rectangle_3535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3535-2",
    "data-name": "Rectangle 3535",
    transform: "translate(1 1)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0.15)",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 36.3,
    height: 36.3,
    rx: 5.65,
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M20.267,21.564,15.59,17.127l-4.677,4.437a1.48,1.48,0,0,1-2.006,0,1.294,1.294,0,0,1,0-1.9l4.677-4.437L8.907,10.787a1.294,1.294,0,0,1,0-1.9,1.48,1.48,0,0,1,2.006,0l4.677,4.437,4.677-4.437a1.48,1.48,0,0,1,2.006,0,1.3,1.3,0,0,1,0,1.9L20.1,12.851l-2.5,2.373,4.677,4.437a1.3,1.3,0,0,1,0,1.9A1.463,1.463,0,0,1,20.267,21.564Z",
    transform: "translate(1242.623 146.404)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.86af0b72fc52ae9b1d09615b98910a8f.svg";
export { ForwardRef as ReactComponent };